import FormularioRow from '../../../../../components/Grid/FormularioRow';
import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { useModalAlert as useIonAlert } from '../../../../../components/Modal/ModalAlert';
import '../../../../../theme/reorder.css';
import { IonButton, IonButtons, IonCol, IonContent, IonFab, IonFabButton, IonFooter, IonGrid, IonHeader, IonIcon, IonInput, IonList, IonLoading, IonModal, IonPage, IonReorderGroup, IonRow, IonSelect, IonSelectOption, IonTitle, IonToast, ItemReorderEventDetail, useIonViewDidEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import { add, arrowBack, listOutline, trashOutline } from 'ionicons/icons';
import React, { useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { alterarItemFormularioEmpresa, empresaCarregar, inserirItemFormularioEmpresa, ordernarItemFormularioEmpresa, removerItemFormularioEmpresa, requestService } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import '../ConfiguracoesLayout.css';

type Props = {
  abrirMenu: boolean;
  onDismiss: () => void;
};

export interface Opcao {
  descricao: string;
}

const FormularioCadastro: React.FC<Props> = (props: Props) => {

  const history = useHistory<any>();
  const [showLoading, setShowLoading] = useState(false);
  const [listaItemFormulario, setListaItemFormulario] = useState<any>([]);

  const [showDetalhes, setShowDetalhes] = useState(false);
  const [indice, setIndice] = useState("");
  const [pergunta, setPergunta] = useState("");
  const [tipo, setTipo] = useState("");
  const [categoria, setCategoria] = useState("");
  const [obrigatorio, setObrigatorio] = useState("");
  const [listaOpcoes, setListaOpcoes] = useState<Opcao[]>([]);

  const [descricaoOpcao, setDescricaoOpcao] = useState("");


  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");
  const [listaCategoria, setListaCategoria] = useState<any>([]);


  const { loja, setLoja } = useContext(MessageContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const podeOrdenar = acessos?.configuracoes === 'edicao';
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);

  const inputRef = useRef<any>(null);

  const [mostartAlerta] = useIonAlert();

  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
    carregarConta();
  });


  function carregarConta() {

    const consultar = async () => {

      console.log("aasasasasa", loja);
      let id = loja;

      requestService(empresaCarregar.url.replace("{id}", id.replaceAll(/#/g, '%23')).concat("?filtro=", Buffer.from(loja).toString("base64")), {
        method: empresaCarregar.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log(response);
          setListaItemFormulario(response.Item.formulario || []);
          setListaCategoria(response.Item.categoriaFormulario || []);
          setShowLoading(false);
        },
        (error: any) => {
          console.log(error);
          history.replace("/login/");
        });

    }

    consultar();
  }



  function deletarItemFormulario(indice: any) {

    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }

    const delItemFormulario = async () => {
      const resp = await fetch(removerItemFormularioEmpresa.url.replace("{id}", loja.replace(/#/g, "%23")),
        {
          method: removerItemFormularioEmpresa.method,
          headers: [
            ["token", token]
          ],
          body: JSON.stringify({ 'indice': indice }),
          credentials: 'include'
        });
      const retorno = await resp.json();
      console.log("retorno", retorno);

      if (retorno && retorno.Item?.Attributes) {
        setTextToast("Item do formulário removido com sucesso.");
        setShowToast(true);
        setListaItemFormulario(retorno.Item?.Attributes?.formulario || []);
      }
      else {
        setTextToast("Ocorreu um erro ao efetuar a exclusão.");
        setShowToast(true);
      }
    }

    delItemFormulario();

  }


  function handleReorder(event: CustomEvent<ItemReorderEventDetail>) {
    if (!podeOrdenar || showLoading || event.detail.from === event.detail.to) {
      event.detail.complete(false);
      return;
    }

    // Before complete is called with the items they will remain in the
    // order before the drag
    // console.log('Before complete', listaItemFormulario);

    // Finish the reorder and position the item in the DOM based on
    // where the gesture ended. Update the items variable to the
    // new order of items
    setListaItemFormulario(event.detail.complete(listaItemFormulario));

    // After complete is called the items will be in the new order
    // console.log('After complete', listaItemFormulario);


    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }

    const ordItemFormulario = async () => {
      const resp = await fetch(ordernarItemFormularioEmpresa.url.replace("{id}", loja.replace(/#/g, "%23")),
        {
          method: ordernarItemFormularioEmpresa.method,
          headers: [
            ["token", token]
          ],
          body: JSON.stringify({ 'formulario': listaItemFormulario }),
          credentials: 'include'
        });
      const retorno = await resp.json();
      console.log("retorno ordenar", retorno);

      if (retorno && retorno.Item?.Attributes) {
        setTextToast("Ordenação alterada com sucesso.");
        setShowToast(true);
        setListaItemFormulario(retorno.Item?.Attributes?.formulario || []);
      }
      else {
        setTextToast("Ocorreu um erro ao ordernar.");
        setShowToast(true);
      }
    }

    ordItemFormulario();

  }


  const loadItemFormulario = () => {
    if (listaItemFormulario == undefined) return;
    if (listaItemFormulario.length === 0) return <div className="config-empty"><IonIcon icon={listOutline} aria-hidden="true" /><h2>Nenhuma pergunta cadastrada</h2><p>Adicione perguntas para montar o formulário das operações.</p></div>;
    return <IonReorderGroup disabled={!podeOrdenar || showLoading} onIonItemReorder={handleReorder}>
      {listaItemFormulario.map((value: any, index: any) => <FormularioRow key={"itemformulario" + index} item={value}
        canReorder={podeOrdenar} canEdit={acessos?.configuracoes === 'edicao'}
        onEdit={() => {
                      setIndice(value.indice);
                      setPergunta(value.pergunta);
                      setTipo(value.tipo);
                      setDescricaoOpcao("");
                      setCategoria(value.categoria);
                      setObrigatorio(value.obrigatorio);

                      let op: Opcao[] = [];
                      value.opcoes?.forEach((value: any) => {
                        op.push({ descricao: value.descricao });
                      });
                      setListaOpcoes(op);

                      setShowDetalhes(true);

                    }}
        onDelete={() => {
                      mostartAlerta({
                        backdropDismiss: false,
                        header: 'Remover item',
                        message: 'Deseja <strong>remover</strong>?',
                        buttons: [
                          {
                            text: 'Cancelar',
                            role: 'cancel',
                          },
                          {
                            text: 'Confirmar',
                            cssClass: 'primary',
                            handler: () => {
                              deletarItemFormulario(value.indice);
                            }
                          }
                        ],
                        onDidDismiss: (e) => console.log('did dismiss'),
                      })
                    }}
        onRequired={() => {
                  if (value.obrigatorio == "sim") {
                    setTextToast("Sim");
                  }
                  else {
                    setTextToast("Não");
                  }
                  setShowToast(true);
                }} />)}
    </IonReorderGroup>;
  }

  function cadastrar() {
    if (!pergunta || pergunta.trim() == ""
      || !tipo || tipo.trim() == ""
      || !categoria || categoria.trim() == ""
      || !obrigatorio || obrigatorio.trim() == "") {
      setTextToast("Todos os campos são obrigatórios.");
      setShowToast(true);
      return false;
    }
    else if (tipo == "select" && listaOpcoes.length == 0) {
      setTextToast("Adicione uma opção quando o campo for do Tipo Seleção.");
      setShowToast(true);
      return false;
    }
    else {



      console.log("indice", indice);
      if (indice != "") {
        const objectRequest = {
          pergunta: pergunta,
          tipo: tipo,
          categoria: categoria,
          obrigatorio: obrigatorio,
          indice: indice,
          opcoes: listaOpcoes
        }
        console.log("objectRequest", objectRequest);

        let id = loja;

        console.log("id", id);

        requestService(
          alterarItemFormularioEmpresa.url.replace("{id}", id.replaceAll("#", "%23")),
          {
            method: alterarItemFormularioEmpresa.method,
            body: JSON.stringify(objectRequest),
            headers: [
              ["token", window.localStorage.getItem("token")]
            ],
            credentials: 'include'
          },
          history,
          (response: any) => {
            console.log(response);
            if (response) {
              setTextToast("Alteração realizada com sucesso.");
              setShowToast(true);

              setListaItemFormulario(response.message.Attributes.formulario || []);
              setShowDetalhes(false);

            } else if (response.status === 400) {
              console.log(response);
              setTextToast("Ocorreu um erro ao efetuar a alteração.");
              setShowToast(true);

            }
            setShowLoading(false);
          },
          (error: any) => {
            console.log(error);
            setTextToast("Ocorreu um erro ao efetuar a alteração.");
            setShowToast(true);
            setShowLoading(false);
          })
      } else {
        const objectRequest = {
          pergunta: pergunta,
          tipo: tipo,
          categoria: categoria,
          obrigatorio: obrigatorio,
          opcoes: listaOpcoes
        }
        console.log("objectRequest", objectRequest);

        let id = loja;

        console.log("id", id);

        requestService(
          inserirItemFormularioEmpresa.url.replace("{id}", id.replaceAll("#", "%23")),
          {
            method: inserirItemFormularioEmpresa.method,
            body: JSON.stringify(objectRequest),
            headers: [
              ["token", window.localStorage.getItem("token")]
            ],
            credentials: 'include'
          },
          history,
          (response: any) => {
            console.log(response);
            if (response) {
              setTextToast("Cadastro realizado com sucesso.");
              setShowToast(true);

              setListaItemFormulario(response.message.Attributes.formulario || []);
              setShowDetalhes(false);

            } else if (response.status === 400) {
              console.log(response);
              setTextToast("Ocorreu um erro ao efetuar o cadastro.");
              setShowToast(true);

            }
            setShowLoading(false);
          },
          (error: any) => {
            console.log(error);
            setTextToast("Ocorreu um erro ao efetuar o cadastro.");
            setShowToast(true);
            setShowLoading(false);
          })
      }
    }

  }

  function readCategoria() {
    return listaCategoria.map((value: any, index: any, array: any) =>
    (
      <IonSelectOption key={value} value={value}>{value}</IonSelectOption>
    )
    )
  };


  function salvarOpcao() {

    if (!descricaoOpcao || descricaoOpcao.trim() == "") {
      setTextToast("Campo Descrição é obrigatório.");
      setShowToast(true);
      return false;
    }
    else {
      let novaOpcao = { descricao: descricaoOpcao };
      setListaOpcoes([...listaOpcoes, novaOpcao]);

      setDescricaoOpcao("");
    }

  }

  function deletarOpcao(index: Number): void {
    // Filtrar a lista de opções para criar uma nova lista excluindo o item na posição index
    const novaListaOpcoes = listaOpcoes.filter((_, i) => i !== index);
    // Atualizar o estado da lista de opções com a nova lista
    setListaOpcoes(novaListaOpcoes);
  }



  function readOpcoes() {
    return listaOpcoes.map((value: any, index: any) => <div className="config-option-row" key={index}>
      <span>{value.descricao}</span><IonButton fill="clear" className="config-delete" aria-label={`Excluir opção ${value.descricao}`} onClick={() => {
                    mostartAlerta({
                      backdropDismiss: false,
                      header: 'Remover item',
                      message: 'Deseja <strong>remover</strong>?',
                      buttons: [
                        {
                          text: 'Cancelar',
                          role: 'cancel',
                        },
                        {
                          text: 'Confirmar',
                          cssClass: 'primary',
                          handler: () => {
                            deletarOpcao(index);
                          }
                        }
                      ],
                      onDidDismiss: (e) => console.log('did dismiss'),
                    })
                  }}><IonIcon slot="icon-only" icon={trashOutline} /></IonButton>
    </div>);
  }

  return (

    <IonPage className="config-layout-page">
      <IonHeader className="ion-no-border">
        <IonToolbar className="config-layout-toolbar">
          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack();/*.replace("/empresa/operacoes", { recarregar: false }); */ }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Formulário</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="config-layout-content" fullscreen={false}>
<IonFab className="config-mobile-add" vertical="bottom" horizontal="center" slot="fixed" hidden={acessos?.configuracoes != 'edicao'}><IonFabButton aria-label="Nova pergunta" onClick={() => {
                  setIndice("");
                  setPergunta("");
                  setTipo("");
                  setDescricaoOpcao("");
                  setCategoria("");
                  setObrigatorio("");
                  setListaOpcoes([]);
                  setShowDetalhes(true);
                }}><IonIcon icon={add} aria-hidden="true" /></IonFabButton></IonFab><div className="config-container config-list-container"><header className="config-heading"><div><h1>Formulário de operações</h1><p>Configure as perguntas, os tipos de resposta e a ordem do formulário.</p></div><IonButton className="config-primary config-desktop-add" hidden={acessos?.configuracoes != 'edicao'} onClick={() => {
                  setIndice("");
                  setPergunta("");
                  setTipo("");
                  setDescricaoOpcao("");
                  setCategoria("");
                  setObrigatorio("");
                  setListaOpcoes([]);
                  setShowDetalhes(true);
                }}><IonIcon slot="start" icon={add} />Nova pergunta</IonButton></header>



<section className="config-grid-card"><div className="config-grid-heading"><h2>Perguntas do formulário</h2><p>{listaItemFormulario.length} {listaItemFormulario.length === 1 ? "pergunta cadastrada" : "perguntas cadastradas"}</p></div><div hidden={listaItemFormulario.length === 0} className={`config-question-head ${podeOrdenar ? 'has-reorder' : ''}`}>{podeOrdenar && <span aria-hidden="true" />}<span>Pergunta</span><span>Tipo</span><span>Categoria</span><span>Obrigatório</span><span>Ações</span></div>{loadItemFormulario()}</section></div>
        <IonModal className="fullscreen-modal config-modal" onDidPresent={() => {
          if (inputRef.current) {
            inputRef.current.setFocus();
          }
        }} isOpen={showDetalhes} onDidDismiss={() => {
          setShowDetalhes(false);
        }}>


          <>
            <IonHeader className="ion-no-border">
              <IonToolbar>
                <IonButtons slot="start">
                  <IonIcon slot="icon-only" icon={arrowBack} onClick={() => setShowDetalhes(false)} />
                </IonButtons>
                <IonTitle>{indice ? "Editar pergunta" : "Nova pergunta"}</IonTitle>
              </IonToolbar>
            </IonHeader>
            <IonContent className="config-layout-content">
              <IonGrid className="config-modal-grid">
                <IonRow>
                  <IonCol>
                    <IonList className="config-modal-fields">
                      {/* Pergunta */}
                      <div className="config-field">
                        <span className="config-label">Pergunta*</span>
                        <IonInput aria-label="Pergunta"
                          placeholder="Digite a pergunta"
                          value={pergunta}
                          ref={(ref) => inputRef.current = ref}
                          autoCorrect='true' autoCapitalize='true'
                          required
                          onIonInput={(e: any) => setPergunta(e.target.value)}
                        />
                      </div>

                      {/* Tipo */}
                      <div className="config-field">
                        <span className="config-label">Tipo*</span>
                        <IonSelect aria-label="Tipo"
                          value={tipo}
                          placeholder="Selecione"
                          onIonChange={e => setTipo(e.detail.value)}
                        >
                          <IonSelectOption value="text">Texto</IonSelectOption>
                          <IonSelectOption value="select">Seleção</IonSelectOption>
                          <IonSelectOption value="image">Fotos</IonSelectOption>
                          <IonSelectOption value="signature">Assinaturas</IonSelectOption>
                        </IonSelect>
                      </div>

                      {/* Descrição da Opção (se o tipo for "select") */}
                      <div className="config-field" hidden={tipo !== "select"}>
                        <span className="config-label">Descrição*</span>
                        <IonInput aria-label="Descrição da opção"
                          placeholder="Digite a opção"
                          value={descricaoOpcao}
                          autoCorrect='true' autoCapitalize='true'
                          required
                          onIonInput={(e: any) => setDescricaoOpcao(e.target.value)}
                        />
                      </div>

                      {/* Botão "Salvar" para a descrição da opção (se o tipo for "select") */}
                      <div className="config-option-add" hidden={tipo !== "select"}>
                        <IonButton className="config-secondary" fill="outline" hidden={tipo !== "select"} onClick={() => salvarOpcao()}>Adicionar</IonButton>
                      </div>
                      {/* Lista de Opções (se o tipo for "select" e houver opções) */}

                      <div className="config-options">

                        <IonList style={{ width: "100%", padding: "0px", margin: "0px" }}>
                          {readOpcoes()}
                        </IonList>

                      </div>

                      {/* Categoria */}
                      <div className="config-field">
                        <span className="config-label">Categoria*</span>
                        <IonSelect aria-label="Categoria"
                          value={categoria}
                          placeholder="Selecione"
                          onIonChange={e => { setCategoria(e.detail.value); }}
                        >
                          {readCategoria()}
                        </IonSelect>
                      </div>

                      {/* Obrigatório */}
                      <div className="config-field">
                        <span className="config-label">Obrigatório*</span>
                        <IonSelect aria-label="Obrigatório"
                          value={obrigatorio}
                          placeholder="Selecione"
                          onIonChange={e => setObrigatorio(e.detail.value)}
                        >
                          <IonSelectOption value="sim">Sim</IonSelectOption>
                          <IonSelectOption value="nao">Não</IonSelectOption>
                        </IonSelect>
                      </div>
                    </IonList>
                  </IonCol>
                </IonRow>
              </IonGrid>

            </IonContent>
            <IonFooter className="ion-no-border config-footer">
              <div className="config-footer-actions">
                <button className="config-save" onClick={() => cadastrar()} type="submit">Cadastrar</button>
              </div>
            </IonFooter>
          </>

        </IonModal>

        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

      </IonContent>

    </IonPage>
  );


};

export default FormularioCadastro;
